module.exports = __webpack_public_path__ + "media/3.f9f55725.mp3";